import 'alpinejs'

window.$ = window.jQuery = require('jquery');
import 'jquery-ui/ui/widgets/autocomplete.js';

window.Swal = require('sweetalert2');

// Boilerplate
require('../plugins');

// import 'bootstrap';
require('../bootstrap');

// window.$ = window.jQuery = require('jquery');
// import 'jquery-ui/ui/widgets/autocomplete.js';

